module.exports = __webpack_public_path__ + "img/banner-1.6eb29920.png";